<template>
  <div class="vendor-documents mt-4">
    <!-- Action Buttons -->
    <div class="d-flex justify-content-end mb-3">
      <b-button
        variant="danger"
        size="sm"
        class="mr-2"
        :disabled="!hasSelected"
        @click="deleteSelected"
      >
        <i class="fas fa-trash-alt"></i>
        Delete Selected
      </b-button>
      <b-button variant="outline-primary" size="sm" @click="addRow">
        <i class="fas fa-plus"></i>
        Add New Row
      </b-button>
    </div>

    <!-- Native Table -->
    <table class="table align-middle">
      <thead class="thead-light">
        <tr>
          <th class="text-center" style="width: 40px">
            <b-form-checkbox v-model="selectAll" @change="toggleAll" />
          </th>
          <th>Document Name</th>
          <th>Document Upload</th>
          <th style="width: 40px"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(doc, index) in documents" :key="index">
          <td class="text-center">
            <b-form-checkbox v-model="doc.selected" @change="updateSelectAll" />
          </td>
          <td style="width: 45%">
            <b-form-select
              v-model="doc.name"
              :options="documentOptions"
              size="sm"
            >
              <template #first>
                <option :value="null" disabled>Select Document</option>
              </template>
            </b-form-select>
          </td>
          <td style="width: 45%">
            <div class="d-flex flex-column">
              <b-form-file
                v-model="doc.file"
                size="sm"
                browse-text="Browse"
                placeholder="Choose file..."
                @change="updateFileName(index)"
              />
              <div>
                <small>
                  File Type :
                  <b>.Pdf</b>
                </small>
                <span class="mx-2">|</span>
                <small>
                  Max File Size :
                  <b>25 MB</b>
                </small>
              </div>
            </div>
          </td>
          <td class="text-center">
            <b-button
              variant="link"
              size="sm"
              class="text-danger p-0"
              @click="deleteRow(index)"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'VendorDocumentTable',
  data() {
    return {
      selectAll: false,
      documents: [
        { selected: true, name: 'NIB', fileName: 'NIB.pdf', file: null },
        { selected: true, name: 'KTP', fileName: 'KTP.pdf', file: null },
        { selected: true, name: 'NPWP', fileName: 'NPWP.pdf', file: null },
        { selected: true, name: 'SIUPAL', fileName: 'SIUPAL.pdf', file: null },
        {
          selected: false,
          name: 'SK KEMENKUMHAM',
          fileName: 'SK_KEMENKUMHAM.pdf',
          file: null,
        },
      ],
      documentOptions: ['NIB', 'KTP', 'NPWP', 'SIUPAL', 'SK KEMENKUMHAM'],
    }
  },
  computed: {
    hasSelected() {
      return this.documents.some((doc) => doc.selected)
    },
  },
  methods: {
    addRow() {
      this.documents.push({
        selected: false,
        name: null,
        fileName: '',
        file: null,
      })
    },
    deleteRow(index) {
      this.documents.splice(index, 1)
    },
    deleteSelected() {
      this.documents = this.documents.filter((doc) => !doc.selected)
      this.selectAll = false
    },
    toggleAll() {
      this.documents.forEach((doc) => (doc.selected = this.selectAll))
    },
    updateSelectAll() {
      this.selectAll = this.documents.every((doc) => doc.selected)
    },
    updateFileName(index) {
      const file = this.documents[index].file
      if (file) this.documents[index].fileName = file.name
    },
  },
}
</script>

<style scoped>
.table th {
  font-weight: 600;
  font-size: 0.9rem;
}

.table td {
  vertical-align: middle;
}

.form-control,
.custom-select {
  font-size: 0.85rem;
}

.table td,
.table th {
  white-space: nowrap;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}
</style>
